import { API_URL } from "../../constants/app";
import { headersJson } from "./requestHeaders";

export async function getUserDeleteAccount(payload) {
  return await fetch(`${API_URL}/user/user-mobile-delete-request`, {
    method: "POST",
    headers: headersJson(),
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      return data;
    });
}
